// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"d8d11296","373":"a2412918","412":"e731c932","442":"409bb7a0","621":"9ff8de29","934":"3d72ace7"}[chunkId] + ".chunk.js";
};